module["exports"] = [
  "###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/building_number.js
// module id = 1281
// module chunks = 0